import { css } from '@emotion/react';
import styled from '@emotion/styled';
import FONT from '../../styles/emotion/fonts';
import COLORS from '../../styles/emotion/colors';
import MEDIA_QUERY from '../../styles/emotion/mediaQuery';
import { PaperTag } from '../Tag/PaperTag';
import { LinkV2 } from '../LinkV2';

import GOLD_FOIL from '../../assets/images/paper/gold_foil_tag@2x.png';

export const Wrapper = styled.div`
  display: block;
  float: none !important;
  font-size: ${FONT.FONT_SIZE_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  max-width: 400px;
  position: relative;
`;

export const CardImageWrapper = styled.div`
  overflow: visible;
  position: relative;
  text-align: center;
`;

export const CardImage = styled.img`
  height: 100%;
  width: 100%;
`;

export const SuiteDetails = styled.div`
  margin-top: 8px;
  padding-left: 12px;
`;

export const CardTitle = styled.div`
  color: ${COLORS.BLACK};
  display: flex;
  font-size: 16px;
  line-height: 20px;

  ${MEDIA_QUERY.MOBILE} {
    flex-direction: column;
  }
`;

export const Card = styled(LinkV2)`
  &:hover {
    text-decoration: none !important;

    ${CardTitle} {
      color: ${COLORS.LINK};
    }
  }
`;

export const CardSubtitle = styled.div`
  color: ${COLORS.EMPEROR};
  font-weight: 400;
  margin-top: 8px;
`;

const tag = css`
  margin-left: 8px;
  width: 94px;

  ${MEDIA_QUERY.TABLET} {
    margin-left: 0;
    margin-top: 8px;
  }
`;

export const FoilTag = styled.div`
  ${tag}
  background: url(${GOLD_FOIL});
  background-repeat: no-repeat;
  background-size: 94px 20px;
  height: 20px;
  width: 94px;
`;

export const Tag = styled(PaperTag)`
  margin-left: 8px;
  width: 94px;

  ${MEDIA_QUERY.TABLET} {
    margin-left: 0;
    margin-top: 8px;
  }
`;
